import React, { useState } from 'react'
import { useFormik } from 'formik';
import * as yup from "yup";
import Button from '@mui/material/Button';
import { saveCourse } from '../MaterialUI';
import { Box, Modal, } from '@mui/material';
import { CrossIcon, SentIcon } from '../svg';
import messageStyle from '../container/studentDashboard/messages.module.css'
import api from '../container/helper/Api';
import { unwrapResult } from '@reduxjs/toolkit';
import Toastify from '../container/helper/Toastify';

const ReviwModal = ({
    closeModal,
    open,
    data
}) => {
    // console.log('data',data);

    const schema = yup.object().shape({
        star: yup.string().required("Rating is required"),
        comment: yup.string().required("Comment is required"),
    })

    const {
        errors,
        values,
        handleChange,
        touched,
        handleBlur,
        handleSubmit,
        setFieldValue,
        resetForm,
    } = useFormik({
        initialValues: {
            star: "",
            comment: "",
        },
        validationSchema: schema,
        onSubmit: (values) => {
            updateSubject(values);
        }
    })
    // console.log('values========', values);
    const updateSubject = async (value) => {
        try {
            // Make the API call with query params and body
            const result = await api.addReview({
                data, // Add the query params
                body: value, // Add the form values as body
            });
            if (result.status === 200) {
                Toastify.success('Feedback Sent Successfully')
            } else {
                Toastify.error(result.data.message)
            }
            unwrapResult(result);
            closeModal();
        } catch (error) {
            console.log("error", error);
        }
    }

    const styles = {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        bgcolor: "white",
        border: "none",
        // padding: "27px 22px",
        height: "fit-content",
        display: "block",
        width: '699px',
        borderRadius: '7px',
        "&:focus": {
            outline: "none",
        },
    };


    const [hoverRating, setHoverRating] = useState(0);

    const handleRating = (rate) => {
        setFieldValue('star', rate);
    };

    const handleHover = (rate) => {
        setHoverRating(rate);
    };



    const getRatingText = (rating) => {
        if (rating === 5) return "Excellent";
        if (rating === 4) return "Good/Amazing";
        if (rating === 3) return "Average";
        if (rating === 2) return "Poor";
        if (rating === 1) return "Terrible";
        return "";
    };


    return (
        <Modal
            open={open}
            onClose={closeModal}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Box sx={styles}>
                <div className={messageStyle.basicInfo}>
                    <div className={messageStyle.notifText}>
                        Write a Review
                    </div>
                    <div onClick={closeModal} style={{ cursor: "pointer" }}>
                        <CrossIcon />
                    </div>
                </div>
                <div style={{ margin: 20 }} className={messageStyle.ratingStyle}>
                    <p className={messageStyle.ratingScore}><span>{values.star} ({getRatingText(values.star)})</span></p>
                    <div className={messageStyle.stars}>
                        {[1, 2, 3, 4, 5].map((star) => (
                            <span
                                key={star}
                                className={`${messageStyle.star} ${(hoverRating || values.star) >= star ? messageStyle.highlighted : ""
                                    }`}
                                onClick={() => handleRating(star)}
                                onMouseEnter={() => handleHover(star)}
                                onMouseLeave={() => setHoverRating(0)}
                            >
                                ★
                            </span>
                        ))}
                    </div>
                    {
                        errors.star && touched.star && <p style={{ color: "red", fontSize: "12px" }}>{errors.star}</p>
                    }
                </div>
                <div style={{ marginTop: 20, marginLeft: 20, marginRight: 20 }}>
                    <label className={messageStyle.label}>Feedback</label>

                    <div className={messageStyle.inputBox} style={{ width: '100%' }}>
                        <input
                            type='text'
                            onBlur={handleBlur}
                            value={values.comment}
                            placeholder='Write your message here..'
                            name="comment"
                            onChange={handleChange}
                        />
                    </div>
                    {
                        errors.comment && touched.comment && <p style={{ color: "red", fontSize: "12px" }}>{errors.comment}</p>
                    }
                </div>

                <div className={messageStyle.bottomButtons}>
                    <div onClick={resetForm} className={messageStyle.cancelStyle}>Cancel</div>
                    <Button sx={saveCourse} onClick={handleSubmit} variant="contained">Submit Review <SentIcon /></Button>
                </div>
            </Box>
        </Modal>
    )
}

export default ReviwModal;